import type { Subscription } from "@/interfaces/subscription.interface";
import { createSlice } from "@reduxjs/toolkit";

interface UserType {
  id: string;
  name: string;
  email: string;
  email_verified_at: Date;
  phone: string;
  phone_verified_at: Date;
  is_default: boolean;
  is_main_business: boolean;
  is_owner: boolean;
  hotels: any[];
  restaurants: any[];
  business: any;
  subscriptions: Subscription[];
}
interface UserState {
  token?: string;
  refreshToken?: string;
  user?: UserType;
  isAuthenticated: boolean;
  hotel?: any;
  restaurant?: any;
  current_subscription?: Subscription;
}

const initialState: UserState = {
  token: undefined,
  refreshToken: undefined,
  user: {} as UserType,
  isAuthenticated: false,
  hotel: undefined,
  restaurant: undefined,
  current_subscription: undefined,
};

const UserSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setUser: (state, action) => {
      const { user } = action.payload;
      state.current_subscription = user.subscription;
      delete user.subscription;
      state.user = user;
    },
    signOut: () => initialState,
    signIn: (state, action) => {
      const { token, refreshToken, user } = action.payload;
      state.token = token;
      state.refreshToken = refreshToken;
      state.user = user;
      state.isAuthenticated = true;
    },
    // Swap in a freshly minted access/refresh token pair after a silent refresh,
    // without disturbing the rest of the session (user, business, subscription).
    setTokens: (state, action) => {
      const { token, refreshToken } = action.payload;
      state.token = token;
      if (refreshToken !== undefined) state.refreshToken = refreshToken;
    },
    setHotel: (state, action) => {
      const { hotel } = action.payload;
      state.hotel = hotel;
    },
    setRestaurant: (state, action) => {
      const { restaurant } = action.payload;
      state.restaurant = restaurant;
    },
  },
});

export const { setUser, signIn, signOut, setTokens, setHotel, setRestaurant } = UserSlice.actions;
export default UserSlice.reducer;
